"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTextarea = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const index_1 = require("./../index");
const Textarea_1 = require("./../Primitives/Textarea");
const styled_components_1 = __importDefault(require("styled-components"));
const Label_1 = require("./Label");
const _1 = require(".");
const FieldError_1 = require("./FieldError");
const InputTextareaWithInvalidStyle = (0, styled_components_1.default)(Textarea_1.Textarea) `
  ${(props) => (0, _1.getInvalidStyle)(props.invalid, props.theme.error)}
`;
const FieldTextarea = (props) => {
    const [field, meta] = (0, formik_1.useField)(props);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Label_1.MultiLineLabel, { ...props }),
        react_1.default.createElement(index_1.Flex, { col: true, noWrap: true },
            react_1.default.createElement("div", { style: { display: "inline-block", position: "relative" } },
                react_1.default.createElement(InputTextareaWithInvalidStyle, { ...props, ...field, disabled: props.disabled, invalid: meta.touched && meta.error !== undefined, id: props.name, "data-testid": `input-${props.name}`, value: props.hideFieldValue ? "" : field.value, placeholder: props.hideFieldValue
                        ? props.conditionalPlaceholder
                        : props.placeholder }))),
        meta.touched && meta.error && (react_1.default.createElement(FieldError_1.FieldError, { "data-testid": `${props.name}Error` }, meta.error))));
};
exports.FieldTextarea = FieldTextarea;
//# sourceMappingURL=FieldTextarea.js.map